export const MOBILE_VIEW = 600;
export const SIDE_MARGIN = 50;
